import fr from 'facet-rest';
import StatusIndicator from 'Components/Modals/UncategorizedMeetingModal/StatusIndicator';

const fieldsToHide = [
  'calendarEventId',
  'householdId',
  'endTime',
  'subject',
  'content',
  'personalizedMessage',
  'link',
  'sendEmail',
  'agendas',
  'messageType',
  'bestNextSteps',
  'clientNoShow',
  'isCancelled',
];
export const UncategorizedMeetingOverride = fr.metaOverride()
  .overrideAll({ _hideLabel: true })
  .nameOverride(fieldsToHide, { hidden: true })
  .nameOverride('startTime', {
    ordinal: 1,
    prompt: 'Date',
    _formatString: 'MM/DD/YYYY',
  })
  .nameOverride('meetingType', {
    ordinal: 2,
    prompt: 'Category',
  })
  .nameOverride('title', {
    ordinal: 3,
  })
  .nameOverride('status', {
    readonly: false,
    _component: () => StatusIndicator,
  });
